module.exports = __webpack_public_path__ + "static/media/4.2843f97c.jpg";